// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/Instagram.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/Instagram.tsx");
  import.meta.hot.lastModified = "1748278914638.2078";
}
// REMIX HMR END

import { useTranslation } from 'react-i18next';
export function Instagram() {
  _s();
  const {
    t
  } = useTranslation();
  const instagramImages = ['/images/instagram/instagram-1.jpg', '/images/instagram/instagram-2.jpg', '/images/instagram/instagram-3.jpg', '/images/instagram/instagram-4.jpg', '/images/instagram/instagram-5.jpg'];
  return <div className="max-w-7xl mx-auto lg:py-[120px] py-[80px] px-6 w-full">
      <h1 className="text-center font-sans uppercase text-grey2 text-xs font-bold pb-6">
        {t('vendure.instagram')}
      </h1>
      <h2 className="text-center font-serif text-[32px] pb-12">
        {'@zlatykrizlahudky'}
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
        {instagramImages.map((image, index) => <a key={index} href="https://www.instagram.com/lahudkyzlatykrizpraha/" target="_blank" rel="noopener noreferrer" className={`block hover:opacity-90 transition-opacity ${index > 0 ? `hidden ${index === 1 ? 'sm:block' : index === 2 ? 'md:block' : index === 3 ? 'lg:block' : 'xl:block'}` : ''}`}>
            <img src={image} alt={`Instagram post ${index + 1}`} className="w-full h-auto object-cover rounded-lg" />
          </a>)}
      </div>
    </div>;
}
_s(Instagram, "zlIdU9EjM2llFt74AbE2KsUJXyM=", false, function () {
  return [useTranslation];
});
_c = Instagram;
var _c;
$RefreshReg$(_c, "Instagram");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;